// src/utils/unprovisionedSignIn.js
//
// One place for "this person signed in, but has no Grateful Sun Energy account".
//
// Two paths reach it:
//   - an Auth account with no users/ doc: userStore signs it out and routes here;
//   - a Google sign-in whose email has no Auth account at all. Public sign-up is
//     closed (2026-09-14), so Firebase refuses to create one and signInWithCredential
//     rejects with `auth/admin-restricted-operation`. Without this mapping the sign-in
//     page showed that raw Firebase text (docs/bugs/signed_in_is_not_staff_BUG.md).
//
// Both land on the same page: SignedOutPage reads `reason=not-provisioned`.

/** A fresh route location each call, so the router never holds a shared object. */
export function notProvisionedRoute() {
  return { name: 'SignedOut', query: { reason: 'not-provisioned' } }
}

/** True when a Firebase sign-in failed because the account would have to be created. */
export function isUnprovisionedSignIn(err) {
  return err?.code === 'auth/admin-restricted-operation'
}
